import { SignatureFormat } from "../signature-types.js";
import { encodeDataUrl, decodeDataUrl } from "./data-url.js";
const encodePoints = (points) => encodeDataUrl({
  data: JSON.stringify(points),
  mimeType: SignatureFormat.POINTS
});
const decodePoints = (dataUrl) => {
  const decodedDataUrl = decodeDataUrl(dataUrl);
  if (decodedDataUrl?.mimeType === SignatureFormat.POINTS) {
    try {
      const points = JSON.parse(decodedDataUrl.data);
      return points;
    } catch (e) {
      return null;
    }
  }
  return null;
};
export {
  decodePoints,
  encodePoints
};
//# sourceMappingURL=points.js.map
